import { IReport, ReportStatus, ReportType } from '@navstation-portal/reporting/data-model/vessel-report';
import { ReducedVesselReport } from '@navstation-portal/reporting/data-model/vessel-reports';

const toIsoString = (date: Date | undefined): string => (date ? new Date(date).toISOString() : '');

const meanOf = (a: number | undefined, b: number | undefined): number => {
  const values = [a, b].filter((value): value is number => typeof value === 'number');
  if (!values.length) return 0;
  return values.reduce((sum, value) => sum + value, 0) / values.length;
};

/**
 * Builds the flat `ReducedVesselReport` list-row shape from the report we already
 * hold in the store. Used after a successful save/submit to upsert the vessel-reports
 * list without a full refetch. The display fields come from the client form —
 * notably the report number is the report's OWN number (`vesselDetails.reportNumber`),
 * not the submit response's number, which is the NEXT report's number.
 */
export function buildReducedVesselReport(
  report: IReport,
  reportType: ReportType,
  { reportId, status }: { reportId: string; status: ReportStatus }
): ReducedVesselReport {
  const { reportTime, operatingConditions, vesselDetails } = report.operational;

  return {
    id: reportId,
    status,
    reportType,
    reportNumber: vesselDetails?.reportNumber ?? 0,
    reportFrom: toIsoString(reportTime?.reportFrom),
    // The EOSP field replaces Report To while the ship arrives at EOSP, and the
    // two are the same instant, so the list row reads whichever holds a value.
    reportTo: toIsoString(reportTime?.eosp ?? reportTime?.reportTo),
    reportToUtc: toIsoString(reportTime?.eosp ?? reportTime?.reportTo),
    reportPeriod: reportTime?.reportPeriod ?? 0,
    meanDraught: meanOf(operatingConditions?.draughtForward, operatingConditions?.draughtAft),
  };
}
